/**
 * FingeringEditorPage (issue #17 Phase 4.3)
 *
 * 案 C-2 採用の wrapper component。
 * - `useFingeringEditor()` を 1 度だけ呼び出し (resize で hook 再初期化なし、 state 保持)
 * - `editor.view.isMobile` で Desktop/Mobile に分岐
 * - `editor` オブジェクトを props として子に渡す
 *
 * 既存テスト互換: DRAG_THRESHOLD_PX を re-export (hook 経由)。
 */
import React from 'react';
import { useFingeringEditor } from '../../hooks/useFingeringEditor';
import { useFingeringClipboard } from '../../hooks/useFingeringClipboard';
import { usePageTitle } from '../../hooks/usePageTitle';
import FingeringEditorPageDesktop from './FingeringEditorPageDesktop';
import FingeringEditorPageMobile from './FingeringEditorPageMobile';

// 既存テスト互換のため re-export (Phase 3.3 で hook 内へ移動済)
export { DRAG_THRESHOLD_PX } from '../../hooks/useFingeringEditor';

const FingeringEditorPage: React.FC = () => {
  usePageTitle('エディタ | おまかせ運指くん');
  const editor = useFingeringEditor();
  // issue #168: 運指コピペ (アプリ内クリップボード + 配置モード) を editor と別 hook で管理。
  const clipboard = useFingeringClipboard(editor);
  return editor.view.isMobile
    ? <FingeringEditorPageMobile editor={editor} clipboard={clipboard} />
    : <FingeringEditorPageDesktop editor={editor} clipboard={clipboard} />;
};

export default FingeringEditorPage;
